import { Directive, ElementRef } from '@angular/core';

import { DropController } from '@anjuna/core';

/**
 * @description A wrapper around the HTML 5 Drop API.
 */
@Directive({
    selector: '[anjDroppable]'
})
export class DroppableDirective {
    private controller: DropController;

    constructor(private element: ElementRef) {
        this.controller = new DropController(this.element.nativeElement).connect();
    }
}
